export default __webpack_public_path__ + "static/media/logo_white background.e981b09d.svg";